import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import {
  useIsOneOnOneAdmin,
  useIsSuperAdminNonImpersonating,
} from 'utils/models/User';
import { useFeatures } from 'utils/util/features';
import Page from '../Layout/Pages/Page';
import { AdministrationTab } from './administrationTabs';
import { OneOnOnesAdminPage } from './ContentAdministration/OneOnOnesAdmin';
import { OneOnOneAgendaTemplatesPage } from './ContentAdministration/TemplatesAdmin';
import { useCreateTemplateAction } from './ContentAdministration/TemplatesAdmin/useCreateTemplateAction';
import OrganizationAudit, {
  AuditEntryType,
} from './PeopleAdministration/Audit/OrganizationAudit';

const OneOnOnesAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();
  const { isEnabled, isGroupAndOptionEnabled } = useFeatures();
  const isOneOnOneAdmin = useIsOneOnOneAdmin();
  const isSuperAdmin = useIsSuperAdminNonImpersonating();
  const { onCreateRef, action } = useCreateTemplateAction();

  const tabs: AdministrationTab[] = [];

  if (
    isEnabled('one_on_ones') &&
    isEnabled('one_on_ones_administration') &&
    isEnabled('content_administration') &&
    (isOneOnOneAdmin || isSuperAdmin)
  ) {
    tabs.push({
      path: consts.ADMINISTRATION_ONE_ON_ONES(formatMessage).path,
      name: consts.ADMINISTRATION_ONE_ON_ONES(formatMessage).name,
      content: <OneOnOnesAdminPage />,
    });

    // the audit trail only records template changes, so both tabs follow
    // the templates flag
    if (
      isGroupAndOptionEnabled('content_administration', 'templates_enabled')
    ) {
      tabs.push({
        path: consts.ADMINISTRATION_ONE_ON_ONES_TEMPLATES(formatMessage).path,
        name: consts.ADMINISTRATION_ONE_ON_ONES_TEMPLATES(formatMessage).name,
        content: <OneOnOneAgendaTemplatesPage onCreateRef={onCreateRef} />,
        action,
      });
      tabs.push({
        path: consts.ADMINISTRATION_ONE_ON_ONES_AUDIT(formatMessage).path,
        name: consts.ADMINISTRATION_ONE_ON_ONES_AUDIT(formatMessage).name,
        content: (
          <OrganizationAudit
            auditEntryTypes={[AuditEntryType.ONE_ON_ONE_MANAGEMENT]}
          />
        ),
      });
    }
  }

  return (
    <Page
      title={consts.ADMINISTRATION_ONE_ON_ONES(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(OneOnOnesAdministrationPage);
